// Depedencies
import ContentLoader from 'react-content-loader'

// Types
import { Components } from '../types';

// TODO: Attribute select scaling separately from product base height
// TODO: Bundle products loader
// TODO: Include base data (numOfAttributes/attributeName/attributeType, productType, ...) to determine a more precise loader 

const paddingBlock = 36;
const paddingInline = 0;

const AttributeSelectLoader = ({width = 90, height = 200, gap = 15, offsetY = 0}: Components.AttributeSelectLoader) => (<> 
    <rect x={paddingInline} y={paddingBlock + offsetY} rx="" ry="0" width={width} height={height / 13} />
    <rect x={paddingInline} y={paddingBlock + (offsetY + (height / 18)) + gap} rx="0" ry="0" width="100%" height={height / 5} />
</>)

const AttributeSwatchesLoader = ({width = 90, height = 200, gap = 15, offsetY = 0, count = 2}: Components.AttributeSelectLoader) => (<> 
    <rect x={paddingInline} y={paddingBlock + offsetY} rx="0" ry="0" width={width} height={height / 13} fillRule="evenodd" /> 
    {[ ...Array(count) ].map((x, i) => 
         <rect key={i} x={paddingInline + ((75 + gap ) * i)} y={(paddingBlock + offsetY + (height / 18) + gap)} rx="0" ry="0" width={75} height={height / 5} />
    ) }
</>)

const BundledLoader = ({width = 90, height = 200, gap = 15, offsetY = 0, count = 2}: Components.AttributeSelectLoader) => (<> 
    <rect x={paddingInline} y={paddingBlock} rx="0" ry="0" width="100%" height={height / 2.5} fillRule="evenodd" /> 
    <rect x={paddingInline} y={paddingBlock+ (height / 2.5) + gap} rx="0" ry="0" width="100%" height={height / 2.5} fillRule="evenodd" /> 
</>)
 
const ProductAreaLoader = ({ width = '100%', height = 200, gap = 15, numOfAttributes = 2, type = 'variable' }: Components.ProductAreaLoader) => (
    <ContentLoader width={width} height={ height + (Number(type !== 'simple') * numOfAttributes * ( (height / 3.5) + (height / 4) + gap) ) }>
        {['variable'].includes(type) && [ ...Array(numOfAttributes) ].map((x, i) => <AttributeSwatchesLoader count={Math.round(Math.random() * (5 - 2) + 2)} key={i} width={90} height={height} gap={gap} offsetY={i * ( (height / 14) + (height / 5.75) + 2 * (gap)) } /> ) }
        {['bundle'].includes(type) && <BundledLoader count={Math.round(Math.random() * (5 - 2) + 2)} width={90} height={height} gap={gap}  />}
        <rect x="0" y={(Number(type === 'variable' || type === 'bundle') * ( ( numOfAttributes * (height / 5.15)) + (numOfAttributes * (height / 4)) + ((numOfAttributes * 2) * gap) ) )} rx="0" ry="0" width="100%" height={height} />
    </ContentLoader>
)

export default ProductAreaLoader;